import { joinPath } from './path';
import { validateResourceQuery } from './validateQuery';

const encodeQueryParameter = param => {
  if (Array.isArray(param)) {
    return param.map(encodeQueryParameter).join(',');
  }

  if (typeof param === 'string') {
    return encodeURIComponent(param);
  }

  if (typeof param === 'number' || typeof param === 'boolean') {
    return String(param);
  }

  if (typeof param === 'object') {
    throw new Error('Object parameter mappings not yet implemented');
  }

  throw new Error('Unknown parameter type');
};

const queryParametersMapToArray = params => Object.keys(params).reduce((out, key) => {
  const value = params[key];

  if (key === 'filter' && Array.isArray(value)) {
    value.forEach(item => {
      out.push({
        key: 'filter',
        value: item
      });
    });
  } else if (params[key] !== null && params[key] !== undefined) {
    out.push({
      key,
      value: params[key]
    });
  }

  return out;
}, []);

const queryParametersToQueryString = params => {
  const expandedParams = queryParametersMapToArray(params);
  return expandedParams.map((_ref) => {
    let {
      key,
      value
    } = _ref;
    return `${encodeURIComponent(key)}=${encodeQueryParameter(value)}`;
  }).join('&');
};

const actionPrefix = 'action::';

const isAction = resource => resource.startsWith(actionPrefix);

const makeActionPath = resource => joinPath('dhis-web-commons', `${resource.substr(actionPrefix.length)}.action`);

const skipApiVersion = (resource, config) => {
  if (resource === 'tracker' || resource.startsWith('tracker/')) {
    var _config$serverVersion, _config$serverVersion2;

    if (!((_config$serverVersion = config.serverVersion) !== null && _config$serverVersion !== void 0 && _config$serverVersion.minor) || ((_config$serverVersion2 = config.serverVersion) === null || _config$serverVersion2 === void 0 ? void 0 : _config$serverVersion2.minor) < 38) {
      return true;
    }
  } // The `/api/ping` endpoint is unversioned


  if (resource === 'ping') {
    return true;
  }

  return false;
};

export const queryToResourcePath = (link, query, type) => {
  const {
    resource,
    id,
    params = {}
  } = query;
  const apiBase = skipApiVersion(resource, link.config) ? link.unversionedApiPath : link.versionedApiPath;
  const base = isAction(resource) ? makeActionPath(resource) : joinPath(apiBase, resource, id);
  validateResourceQuery(query, type);

  if (Object.keys(params).length) {
    return `${base}?${queryParametersToQueryString(params)}`;
  }

  return base;
};